import axios from 'axios'
import { IGetReasonCodes } from '../models/systemConfiguration'
import axiosInstance from '../utils/api-util/utilApi'
import { ApiResponse } from '../models/common.model'

export const getCriticalSystemConfiguration = (tenantId?: string): Promise<any> => {
  return axios.get(`${process.env.REACT_APP_MASTER_SETUP_SERVICE_URL}/api/criticalSystemConfiguration`)
}

export const getDeferredConfiguration = (): Promise<any> => {
  return axios.get(`${process.env.REACT_APP_MASTER_SETUP_SERVICE_URL}/api/SystemConfigurations/major`)
}

export const fetchLookupValues = (): Promise<any> => {
  return axios.get(`${process.env.REACT_APP_MASTER_SETUP_SERVICE_URL}/api/SystemConfigurations/lookupValues`)
}

export const getTimeZones = (): Promise<any> => {
  return axios.get(`${process.env.REACT_APP_MASTER_SETUP_SERVICE_URL}/api/SystemConfigurations/timeZones`)
}

export const getReasonCodes = (params: IGetReasonCodes.Payload): Promise<ApiResponse<IGetReasonCodes.Response>> => {
  return axiosInstance.get(`${process.env.REACT_APP_MASTER_SETUP_SERVICE_URL}/api/SystemConfigurations/reasonCodes`, {
    params,
  })
}
